import { dateFormatter } from "../../../../../config/Global";
import {
  idColumn,
  actionColumn,
  statusColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, setDateFilterDefs } from "../../../../../utils/commonFunctions";
import { dateFormats } from "../../utils/constats";

const useColumnDefs = [
  idColumn,
  {
    ...generateColumn("", "module"),
  },
  {
    ...generateColumn("User Name", ""),
    cellRenderer: (props: any) => {
      return `${props.data.created_by.name} ${props.data.created_by.last_name}`;
    },
    filterValueGetter: (props: any) => {
      return `${props.data.created_by.name} ${props.data.created_by.last_name}`;
    },
    valueGetter: (props: any) => {
      return `${props.data.created_by.name} ${props.data.created_by.last_name}`;
    },
  },
  {
    ...generateColumn("User Email", ""),
    cellRenderer: (props: any) => {
      return props.data.created_by.email;
    },
    filterValueGetter: (props: any) => {
      return props.data.created_by.email;
    },
    valueGetter: (props: any) => {
      return props.data.created_by.email;
    },
  },
  
  {
    ...{
      field: "data.created_at",
      headerName: "Date",
      cellRenderer: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at, dateFormats.dateFormat)
          : "N/A";
      },
    },
    ...setDateFilterDefs()
  },
  {
    ...{
      field: "data.created_at",
      headerName: "Time",
      cellRenderer: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at,  dateFormats.timeFormat)
          : "N/A";
      },
      filterValueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at,  dateFormats.timeFormat)
          : "N/A";
      },
      valueGetter: (props: any) => {
        return props.data.created_at
          ? dateFormatter(props.data.created_at,  dateFormats.timeFormat)
          : "N/A";
      },
    },
  },
  actionColumn,
];
export default useColumnDefs;
